// Minimize / maximize / close, drawn by the shell where the host hands them
// over (the desktop app on Windows and Linux; on mac the traffic lights are the
// window's own). They stand at the right end of the panel's first header row,
// in the row's own button shape, level with its buttons and as close together;
// the header rows under them keep that end free (`useTitleBarClear`). Above
// every layer (dialogs, the media viewers), as the window's own buttons would
// be.
import { m } from "@trameria/i18n";
import { useSyncExternalStore } from "react";
import { ICON_BUTTON } from "../ui/button";
import { Icon } from "../ui/icon";
import {
  WINDOW_BUTTON_GAP,
  WINDOW_BUTTONS_END,
  WINDOW_BUTTONS_TOP,
  type WindowControls,
} from "./title-bar";

export function WindowControlButtons({
  controls,
}: {
  controls: WindowControls;
}) {
  const maximized = useSyncExternalStore(
    controls.onMaximizedChange,
    controls.isMaximized,
    () => false,
  );
  const buttons = [
    {
      label: m.shell_window_minimize(),
      icon: "window-minimize",
      run: controls.minimize,
    },
    {
      label: maximized ? m.shell_window_restore() : m.shell_window_maximize(),
      icon: maximized ? "window-restore" : "window-maximize",
      run: controls.toggleMaximize,
    },
    { label: m.shell_window_close(), icon: "close", run: controls.close },
  ] as const;
  return (
    <div
      data-window-controls=""
      className="fixed z-[70] flex"
      style={{
        top: WINDOW_BUTTONS_TOP,
        right: WINDOW_BUTTONS_END,
        gap: WINDOW_BUTTON_GAP,
      }}
    >
      {/* No tooltips: above the first row they would leave the window, and
          these three are the same in every app. */}
      {buttons.map((b) => (
        <button
          key={b.icon}
          type="button"
          aria-label={b.label}
          onClick={() => b.run()}
          className={ICON_BUTTON}
        >
          <Icon kind={b.icon} size={14} />
        </button>
      ))}
    </div>
  );
}
